// extracted by mini-css-extract-plugin
module.exports = {"activitesMobile":"activities_activitesMobile__1vimD","activitesMobile__cards":"activities_activitesMobile__cards__1HIvh","SpaVisuals":"activities_SpaVisuals__1Y4b8"};